import Vue from 'vue';
import Vuex from 'vuex';
import getters from '@/store/getters';

Vue.use(Vuex);

// webpack检测
// https://webpack.js.org/guides/dependency-management/#requirecontext
const modulesFiles = require.context('./modules', true, /\.js$/);
// 引入modules中的所有store模块
const modules = modulesFiles.keys().reduce((modules, modulePath) => {
  // set './app.js' => 'app'
  const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1');
  const value = modulesFiles(modulePath);
  modules[moduleName] = value.default;
  return modules;
}, {});

// eslint-disable-next-line
const store = new Vuex.Store({
  modules,
  getters,
});

export default store;
